// Folio Detail Management & Live Sync Module
// Fully CSP-compliant: zero inline script blocks, delegated event handling on document, Turbo-resilient

let currentIndividualTarget = null
let syncTimer = null
let isFetching = false

function escapeHtml (str) {
  if (!str) return ''
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

export function openBulkResendModal () {
  const modal = document.getElementById('bulk-resend-modal')
  if (modal) modal.classList.remove('hidden')
}

export function closeBulkResendModal () {
  const modal = document.getElementById('bulk-resend-modal')
  if (modal) modal.classList.add('hidden')
}

export function openEmailTemplateModal () {
  const modal = document.getElementById('folio-email-template-modal')
  if (modal) {
    modal.classList.remove('hidden')
    switchEmailTab('edit')
  }
}

export function closeEmailTemplateModal () {
  const modal = document.getElementById('folio-email-template-modal')
  if (modal) modal.classList.add('hidden')
}

export function switchEmailTab (tab) {
  const editTab = document.getElementById('folio-email-tab-edit')
  const previewTab = document.getElementById('folio-email-tab-preview')
  const editPanel = document.getElementById('folio-email-edit-panel')
  const previewPanel = document.getElementById('folio-email-preview-panel')

  if (tab === 'edit') {
    editTab?.classList.add('bg-white', 'text-[#043f42]', 'shadow-xs', 'font-bold')
    editTab?.classList.remove('text-[#6b7280]')
    previewTab?.classList.remove('bg-white', 'text-[#043f42]', 'shadow-xs', 'font-bold')
    previewTab?.classList.add('text-[#6b7280]')
    editPanel?.classList.remove('hidden')
    previewPanel?.classList.add('hidden')
  } else {
    previewTab?.classList.add('bg-white', 'text-[#043f42]', 'shadow-xs', 'font-bold')
    previewTab?.classList.remove('text-[#6b7280]')
    editTab?.classList.remove('bg-white', 'text-[#043f42]', 'shadow-xs', 'font-bold')
    editTab?.classList.add('text-[#6b7280]')
    editPanel?.classList.add('hidden')
    previewPanel?.classList.remove('hidden')

    renderEmailPreview()
  }
}

export function renderEmailPreview () {
  const titleEl = document.getElementById('folio-email-template-modal-title')
  const templateName = titleEl?.dataset.templateName || 'Document'
  const accountName = titleEl?.dataset.accountName || 'Doccu'
  const subjectInput = document.getElementById('folio-email-subject-input')
  const bodyInput = document.getElementById('folio-email-body-input')
  const subjectDisplay = document.getElementById('folio-email-preview-subject-display')
  const bodyContent = document.getElementById('folio-email-preview-body-content')

  let subject = subjectInput?.value || ''
  subject = subject
    .replace(/\{\{template\.name\}\}/gi, templateName)
    .replace(/\{\{account\.name\}\}/gi, accountName)
    .replace(/\{\{submitter\.name\}\}/gi, 'Nkosi Mnguni')
    .replace(/\{\{submitter\.first_name\}\}/gi, 'Nkosi')
    .replace(/\{\{submitter\.email\}\}/gi, 'stu006_85911_49@maxxspace.com')
    .replace(/\{\{sender\.name\}\}/gi, 'John Doe')

  if (subjectDisplay) subjectDisplay.textContent = subject

  let body = bodyInput?.value || ''
  body = body
    .replace(/\{\{template\.name\}\}/gi, templateName)
    .replace(/\{\{account\.name\}\}/gi, accountName)
    .replace(/\{\{submitter\.name\}\}/gi, 'Nkosi Mnguni')
    .replace(/\{\{submitter\.first_name\}\}/gi, 'Nkosi')
    .replace(/\{\{submitter\.email\}\}/gi, 'stu006_85911_49@maxxspace.com')
    .replace(/\{\{sender\.name\}\}/gi, 'John Doe')

  if (bodyContent) {
    bodyContent.innerHTML = ''
    if (body.match(/\{\{submitter\.link\}\}/gi)) {
      const parts = body.split(/\{\{submitter\.link\}\}/gi)
      parts.forEach((part, idx) => {
        if (part) {
          const span = document.createElement('span')
          span.textContent = part
          bodyContent.appendChild(span)
        }
        if (idx < parts.length - 1) {
          const btnWrapper = document.createElement('div')
          btnWrapper.className = 'my-4 text-center'
          btnWrapper.innerHTML = '<span class="inline-block bg-[#01d680] text-[#043f42] font-bold px-6 py-2.5 rounded-full text-xs sm:text-sm select-none shadow-xs">Review and Sign Document</span>'
          bodyContent.appendChild(btnWrapper)
        }
      })
    } else {
      const span = document.createElement('span')
      span.textContent = body
      bodyContent.appendChild(span)
      const btnWrapper = document.createElement('div')
      btnWrapper.className = 'my-4 text-center'
      btnWrapper.innerHTML = '<span class="inline-block bg-[#01d680] text-[#043f42] font-bold px-6 py-2.5 rounded-full text-xs sm:text-sm select-none shadow-xs">Review and Sign Document</span>'
      bodyContent.appendChild(btnWrapper)
    }
  }
}

export function insertEmailTag (tag) {
  const textarea = document.getElementById('folio-email-body-input')
  if (!textarea) return
  const start = textarea.selectionStart
  const end = textarea.selectionEnd
  const text = textarea.value
  textarea.value = text.substring(0, start) + tag + text.substring(end)
  textarea.focus()
  textarea.selectionStart = textarea.selectionEnd = start + tag.length
}

export function resetEmailDefault () {
  const subjectInput = document.getElementById('folio-email-subject-input')
  const bodyInput = document.getElementById('folio-email-body-input')

  if (subjectInput) {
    subjectInput.value = 'Action Required: Please sign {{template.name}}'
  }
  if (bodyInput) {
    bodyInput.value = 'Hi {{submitter.name}},\n\n{{sender.name}} from {{account.name}} has invited you to review and electronically sign {{template.name}}.\n\nPlease click the button below to review and sign the document:\n\n{{submitter.link}}\n\nIf you have any questions or require assistance, please reply directly to this email.\n\nThanks,\n{{account.name}}'
  }
}

export function saveEmailTemplate () {
  const btn = document.getElementById('folio-email-save-btn')
  const updateUrl = btn?.dataset.updateUrl
  if (!updateUrl) return

  const subjectInput = document.getElementById('folio-email-subject-input')
  const bodyInput = document.getElementById('folio-email-body-input')
  const subject = subjectInput?.value.trim() || ''
  const body = bodyInput?.value.trim() || ''

  if (btn) {
    btn.disabled = true
    btn.innerHTML = `
      <svg class="animate-spin h-3.5 w-3.5 text-[#043f42]" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
      </svg>
      <span>Saving...</span>
    `
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  window.fetch(updateUrl, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: JSON.stringify({
      subject,
      body,
      email_templates: {
        signatory: {
          subject,
          body
        }
      }
    })
  })
    .then((res) => {
      if (!res.ok) throw new Error('Failed to save email template')
      return res.json()
    })
    .then(() => {
      closeEmailTemplateModal()
      if (typeof window.showFlash === 'function') {
        window.showFlash('notice', 'Email template updated successfully!')
      } else {
        alert('Email template updated successfully!')
      }
    })
    .catch((err) => {
      console.error(err)
      alert('Failed to save email template: ' + err.message)
    })
    .finally(() => {
      if (btn) {
        btn.disabled = false
        btn.innerHTML = '<span>Save Template</span>'
      }
    })
}

export function openIndividualResendModal (submitterId, submissionId, name) {
  currentIndividualTarget = { submitterId, submissionId }
  const nameEl = document.getElementById('individual-resend-target-name')
  if (nameEl) nameEl.textContent = name || ''
  const modal = document.getElementById('individual-resend-modal')
  if (modal) modal.classList.remove('hidden')
}

export function closeIndividualResendModal () {
  const modal = document.getElementById('individual-resend-modal')
  if (modal) modal.classList.add('hidden')
  currentIndividualTarget = null
}

export function executeIndividualResend () {
  if (!currentIndividualTarget) return
  const btn = document.getElementById('individual-resend-confirm-btn')
  if (btn) {
    btn.disabled = true
    btn.textContent = 'Resending...'
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  window.fetch(`/submissions/${currentIndividualTarget.submissionId}/resend_email`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: JSON.stringify({ submitter_id: currentIndividualTarget.submitterId })
  }).then((res) => {
    if (res.ok) {
      closeIndividualResendModal()
      if (typeof window.showFlash === 'function') {
        window.showFlash('notice', 'Signing invitation resent successfully.')
      }
      // Trigger a sync or smooth reload
      setTimeout(() => {
        window.location.reload()
      }, 400)
    } else {
      alert('Failed to resend email.')
      if (btn) {
        btn.disabled = false
        btn.textContent = 'Confirm & Resend'
      }
    }
  }).catch((err) => {
    console.error(err)
    alert('An error occurred while resending email.')
    if (btn) {
      btn.disabled = false
      btn.textContent = 'Confirm & Resend'
    }
  })
}

export function startEditEmail (submitterId, email) {
  // Desktop elements
  const displayEls = document.querySelectorAll(`[data-email-display-for="${submitterId}"]`)
  const editEls = document.querySelectorAll(`[data-email-edit-for="${submitterId}"]`)
  const inputEls = document.querySelectorAll(`[data-email-input-for="${submitterId}"]`)

  displayEls.forEach((el) => el.classList.add('hidden'))
  editEls.forEach((el) => {
    el.classList.remove('hidden')
    el.classList.add('flex')
  })
  inputEls.forEach((input) => {
    if (email) input.value = email
    input.focus()
  })
}

export function cancelEditEmail (submitterId) {
  const displayEls = document.querySelectorAll(`[data-email-display-for="${submitterId}"]`)
  const editEls = document.querySelectorAll(`[data-email-edit-for="${submitterId}"]`)

  editEls.forEach((el) => {
    el.classList.add('hidden')
    el.classList.remove('flex')
  })
  displayEls.forEach((el) => el.classList.remove('hidden'))
}

export function saveSubmitterEmail (submitterId) {
  const inputEl = document.querySelector(`[data-email-input-for="${submitterId}"]`)
  if (!inputEl) return
  const newEmail = inputEl.value.trim()
  if (!newEmail) {
    alert('Email cannot be blank.')
    return
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  window.fetch(`/submitters/${submitterId}`, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: JSON.stringify({ submitter: { email: newEmail } })
  }).then((res) => {
    return res.json().then((data) => {
      if (res.ok && data.success) {
        const textEls = document.querySelectorAll(`[data-email-text-for="${submitterId}"]`)
        textEls.forEach((textEl) => {
          textEl.textContent = newEmail.length > 21 ? newEmail.substring(0, 18) + '...' : newEmail
          textEl.title = newEmail
        })
        cancelEditEmail(submitterId)
        if (typeof window.showFlash === 'function') {
          window.showFlash('notice', 'Signatory email updated.')
        }
      } else {
        alert(data.error || 'Failed to update email.')
      }
    })
  }).catch((err) => {
    console.error(err)
    alert('An error occurred while updating email.')
  })
}

export function showFolioZipProgress (total) {
  const container = document.getElementById('folio-zip-progress-container')
  const card = document.getElementById('folio-zip-progress-card')
  const fab = document.getElementById('folio-zip-progress-fab')
  const bar = document.getElementById('folio-zip-progress-bar')
  const counter = document.getElementById('folio-zip-counter')
  const label = document.getElementById('folio-zip-status-label')
  const fabCircle = document.getElementById('folio-zip-fab-circle')

  if (container) container.classList.remove('hidden')
  if (card) card.classList.remove('hidden')
  if (fab) fab.classList.add('hidden')
  if (bar) bar.style.width = '0%'
  if (counter) counter.textContent = `0 / ${total || 0}`
  if (label) label.textContent = 'Initializing...'
  if (fabCircle) fabCircle.style.strokeDashoffset = '163.36'
}

export function minimizeFolioZipProgress () {
  const card = document.getElementById('folio-zip-progress-card')
  const fab = document.getElementById('folio-zip-progress-fab')
  if (card) card.classList.add('hidden')
  if (fab) fab.classList.remove('hidden')
}

export function expandFolioZipProgress () {
  const card = document.getElementById('folio-zip-progress-card')
  const fab = document.getElementById('folio-zip-progress-fab')
  if (card) card.classList.remove('hidden')
  if (fab) fab.classList.add('hidden')
}

export function hideFolioZipProgress () {
  const container = document.getElementById('folio-zip-progress-container')
  if (container) container.classList.add('hidden')
}

export function updateFolioZipProgress (current, total, name) {
  const container = document.getElementById('folio-zip-progress-container')
  const bar = document.getElementById('folio-zip-progress-bar')
  const counter = document.getElementById('folio-zip-counter')
  const label = document.getElementById('folio-zip-status-label')
  const fabCircle = document.getElementById('folio-zip-fab-circle')

  if (container && container.classList.contains('hidden')) {
    showFolioZipProgress(total)
  }

  const pct = total > 0 ? Math.round((current / total) * 100) : 0
  if (bar) bar.style.width = `${pct}%`
  if (counter) counter.textContent = `${current} / ${total}`
  if (label) {
    if (name) {
      label.innerHTML = `Processing: <span class="font-semibold text-[#4a5568]">${escapeHtml(name)}</span>`
    } else {
      label.textContent = 'Processing...'
    }
  }
  if (fabCircle) {
    const circumference = 163.36
    const offset = total > 0 ? circumference * (1 - (current / total)) : circumference
    fabCircle.style.strokeDashoffset = offset.toString()
  }
}

export function triggerFolioBulkDownload (btn, url) {
  if (!btn || btn.disabled) return
  btn.disabled = true
  const textEl = document.getElementById('folio-download-all-text')
  if (textEl) textEl.textContent = 'Compiling ZIP...'
  const totalCount = parseInt(btn.dataset.submittersCount || '0', 10)
  showFolioZipProgress(totalCount)

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  window.fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    }
  }).then((res) => {
    if (res.status === 409) {
      alert('A bulk download is already in progress for your account.')
      if (textEl) textEl.textContent = 'Download All'
      btn.disabled = false
      hideFolioZipProgress()
    } else if (!res.ok) {
      alert('Failed to start bulk download.')
      if (textEl) textEl.textContent = 'Download All'
      btn.disabled = false
      hideFolioZipProgress()
    }
  }).catch((err) => {
    console.error(err)
    alert('Failed to start bulk download.')
    if (textEl) textEl.textContent = 'Download All'
    btn.disabled = false
    hideFolioZipProgress()
  })
}

// In-place title editing
export function startEditTitle () {
  const display = document.getElementById('folio-title-display')
  const edit = document.getElementById('folio-title-edit')
  const input = document.getElementById('folio-title-input')
  if (!display || !edit || !input) return

  display.classList.add('hidden')
  edit.classList.remove('hidden')
  edit.classList.add('flex')
  input.focus()
  input.select()
}

export function cancelEditTitle () {
  const display = document.getElementById('folio-title-display')
  const edit = document.getElementById('folio-title-edit')
  const input = document.getElementById('folio-title-input')
  const textEl = document.getElementById('folio-title-text')
  if (!display || !edit) return

  if (input && textEl) {
    input.value = textEl.textContent.trim()
  }
  edit.classList.add('hidden')
  edit.classList.remove('flex')
  display.classList.remove('hidden')
}

export function saveEditTitle () {
  const input = document.getElementById('folio-title-input')
  const textEl = document.getElementById('folio-title-text')
  if (!input || !textEl) return

  const newTitle = input.value.trim()
  if (!newTitle) {
    alert('Folio name cannot be blank.')
    input.focus()
    return
  }

  const url = input.dataset.updateUrl
  if (!url) return

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

  window.fetch(url, {
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: JSON.stringify({
      template: {
        name: newTitle
      }
    })
  }).then(async (res) => {
    if (!res.ok) {
      const data = await res.json().catch(() => ({}))
      throw new Error(data.error || 'Failed to update folio name')
    }
    return res.json().catch(() => ({ name: newTitle }))
  }).then((data) => {
    const updatedName = data.name || newTitle
    textEl.textContent = updatedName
    textEl.setAttribute('title', updatedName)
    const lastCrumb = document.querySelector('.breadcrumbs li:last-child span, .breadcrumbs li:last-child a')
    if (lastCrumb) lastCrumb.textContent = updatedName

    cancelEditTitle()
  }).catch((err) => {
    console.error(err)
    alert(err.message || 'Failed to update folio name.')
  })
}

// Submitter selection & bulk operations
export function updateSelectionState () {
  const checkboxes = document.querySelectorAll('[data-submitter-checkbox]')
  const master = document.getElementById('folio-master-checkbox')
  const bar = document.getElementById('folio-bulk-action-bar')
  const countEl = document.getElementById('folio-selected-count')
  const resendBtn = document.getElementById('folio-bulk-resend-btn')
  const deleteBtn = document.getElementById('folio-bulk-delete-btn')

  const checkedBoxes = Array.from(checkboxes).filter(cb => cb.checked)
  const checkedCount = checkedBoxes.length

  if (master) {
    if (checkedCount === 0) {
      master.checked = false
      master.indeterminate = false
    } else if (checkedCount === checkboxes.length) {
      master.checked = true
      master.indeterminate = false
    } else {
      master.checked = false
      master.indeterminate = true
    }
  }

  if (bar) {
    if (checkedCount > 0) {
      bar.classList.remove('hidden')
      bar.classList.add('flex')
    } else {
      bar.classList.add('hidden')
      bar.classList.remove('flex')
    }
  }

  if (countEl) {
    countEl.textContent = `${checkedCount} selected`
  }

  if (resendBtn) {
    const hasPending = checkedBoxes.some(cb => cb.dataset.submitterCompleted !== 'true')
    resendBtn.disabled = !hasPending
    if (!hasPending && checkedCount > 0) {
      resendBtn.setAttribute('title', 'Selected signatories have already completed signing.')
    } else {
      resendBtn.removeAttribute('title')
    }
  }

  if (deleteBtn) {
    const hasDeletable = checkedBoxes.some(cb => cb.dataset.submitterCompleted !== 'true' && cb.dataset.submitterDeclined !== 'true')
    deleteBtn.disabled = !hasDeletable
    if (!hasDeletable && checkedCount > 0) {
      deleteBtn.setAttribute('title', 'Completed or declined signatories cannot be deleted.')
    } else {
      deleteBtn.removeAttribute('title')
    }
  }
}

export function toggleMasterCheckbox () {
  const master = document.getElementById('folio-master-checkbox')
  if (!master) return
  const isChecked = master.checked
  const checkboxes = document.querySelectorAll('[data-submitter-checkbox]')
  checkboxes.forEach(cb => {
    cb.checked = isChecked
  })
  updateSelectionState()
}

export function deselectAll () {
  const checkboxes = document.querySelectorAll('[data-submitter-checkbox]')
  checkboxes.forEach(cb => {
    cb.checked = false
  })
  const master = document.getElementById('folio-master-checkbox')
  if (master) {
    master.checked = false
    master.indeterminate = false
  }
  updateSelectionState()
}

export function bulkResendSelected () {
  const checkedBoxes = Array.from(document.querySelectorAll('[data-submitter-checkbox]:checked'))
  const pendingBoxes = checkedBoxes.filter(cb => cb.dataset.submitterCompleted !== 'true')

  if (pendingBoxes.length === 0) {
    alert('No pending signatories selected to resend.')
    return
  }

  const ids = pendingBoxes.map(cb => cb.dataset.submitterId)
  const resendBtn = document.getElementById('folio-bulk-resend-btn')
  const url = resendBtn?.dataset.resendUrl

  if (!url) return

  if (!window.confirm(`Resend signing invitations to ${ids.length} selected signatory(ies)?`)) {
    return
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  const formData = new FormData()
  ids.forEach(id => formData.append('submitter_ids[]', id))

  resendBtn.disabled = true
  window.fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: formData
  }).then(async (res) => {
    if (!res.ok) throw new Error('Failed to resend invitations')
    return res.json().catch(() => ({}))
  }).then((data) => {
    deselectAll()
    alert(data.message || `Invitations resent to ${ids.length} signatories.`)
    window.location.reload()
  }).catch((err) => {
    console.error(err)
    alert('Failed to resend invitations.')
    resendBtn.disabled = false
  })
}

export function bulkDeleteSelected () {
  const checkedBoxes = Array.from(document.querySelectorAll('[data-submitter-checkbox]:checked'))
  const deletableBoxes = checkedBoxes.filter(cb => cb.dataset.submitterCompleted !== 'true' && cb.dataset.submitterDeclined !== 'true')

  if (deletableBoxes.length === 0) {
    alert('None of the selected signatories can be removed (completed or declined).')
    return
  }

  const ids = deletableBoxes.map(cb => cb.dataset.submitterId)
  const deleteBtn = document.getElementById('folio-bulk-delete-btn')
  const url = deleteBtn?.dataset.deleteUrl

  if (!url) return

  if (!window.confirm(`Remove ${ids.length} selected signatory(ies) from this folio?`)) {
    return
  }

  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
  const formData = new FormData()
  ids.forEach(id => formData.append('submitter_ids[]', id))

  deleteBtn.disabled = true
  window.fetch(url, {
    method: 'POST',
    headers: {
      'X-CSRF-Token': csrfToken,
      Accept: 'application/json'
    },
    body: formData
  }).then(async (res) => {
    if (!res.ok) throw new Error('Failed to delete signatories')
    return res.json().catch(() => ({}))
  }).then(() => {
    deselectAll()
    window.location.reload()
  }).catch((err) => {
    console.error(err)
    alert('Failed to delete signatories.')
    deleteBtn.disabled = false
  })
}

export function toggleStatusKebab () {
  const btn = document.getElementById('folio-status-kebab-btn')
  const menu = document.getElementById('folio-status-kebab-menu')
  if (!btn || !menu) return

  const isHidden = menu.classList.contains('hidden')
  if (isHidden) {
    if (menu.parentElement !== document.body) {
      document.body.appendChild(menu)
    }
    const rect = btn.getBoundingClientRect()
    menu.style.position = 'fixed'
    menu.style.top = `${rect.bottom + 6}px`
    const menuWidth = menu.offsetWidth || 208
    let left = rect.right - menuWidth
    if (left < 10) left = 10
    if (left + menuWidth > window.innerWidth - 10) {
      left = window.innerWidth - menuWidth - 10
    }
    menu.style.left = `${left}px`
    menu.style.zIndex = '99999'
    menu.classList.remove('hidden')
    btn.setAttribute('aria-expanded', 'true')
  } else {
    menu.classList.add('hidden')
    btn.setAttribute('aria-expanded', 'false')
  }
}

export function closeStatusKebab () {
  const menu = document.getElementById('folio-status-kebab-menu')
  const btn = document.getElementById('folio-status-kebab-btn')
  if (menu && !menu.classList.contains('hidden')) {
    menu.classList.add('hidden')
  }
  if (btn) {
    btn.setAttribute('aria-expanded', 'false')
  }
}

// Global delegated click handling
document.addEventListener('click', (e) => {
  const kebabMenu = document.getElementById('folio-status-kebab-menu')
  if (kebabMenu && !kebabMenu.classList.contains('hidden')) {
    const isInsideMenu = kebabMenu.contains(e.target)
    const isKebabBtn = e.target.closest('#folio-status-kebab-btn')
    if (!isInsideMenu && !isKebabBtn) {
      closeStatusKebab()
    } else if (isInsideMenu && e.target.closest('a')) {
      closeStatusKebab()
    }
  }

  const trigger = e.target.closest('[data-folio-detail-action]')
  if (!trigger) return

  const action = trigger.dataset.folioDetailAction

  // If opening command-centre, ensure inner buttons/links don't get swallowed
  if (action === 'open-command-centre') {
    if (e.target.closest('button, a, input, [data-prevent-command-centre]')) {
      return
    }
    const submitterId = trigger.dataset.submitterId
    if (submitterId) {
      window.dispatchEvent(new CustomEvent('command-centre:open', {
        detail: { submitterId: parseInt(submitterId, 10) }
      }))
    }
    return
  }

  switch (action) {
    case 'toggle-status-kebab':
      e.preventDefault()
      e.stopPropagation()
      toggleStatusKebab()
      break
    case 'open-bulk-resend':
      e.preventDefault()
      openBulkResendModal()
      break
    case 'close-bulk-resend':
      e.preventDefault()
      closeBulkResendModal()
      break
    case 'open-resend-modal': {
      e.preventDefault()
      e.stopPropagation()
      const { submitterId, submissionId, submitterName } = trigger.dataset
      openIndividualResendModal(submitterId, submissionId, submitterName)
      break
    }
    case 'close-resend-modal':
      e.preventDefault()
      closeIndividualResendModal()
      break
    case 'confirm-individual-resend':
      e.preventDefault()
      executeIndividualResend()
      break
    case 'start-edit-email': {
      e.preventDefault()
      e.stopPropagation()
      const { submitterId, submitterEmail } = trigger.dataset
      startEditEmail(submitterId, submitterEmail)
      break
    }
    case 'save-edit-email': {
      e.preventDefault()
      e.stopPropagation()
      const submitterId = trigger.dataset.submitterId
      saveSubmitterEmail(submitterId)
      break
    }
    case 'cancel-edit-email': {
      e.preventDefault()
      e.stopPropagation()
      const submitterId = trigger.dataset.submitterId
      cancelEditEmail(submitterId)
      break
    }
    case 'bulk-download': {
      e.preventDefault()
      const url = trigger.dataset.downloadUrl
      if (url) triggerFolioBulkDownload(trigger, url)
      break
    }
    case 'minimize-zip-progress':
      e.preventDefault()
      minimizeFolioZipProgress()
      break
    case 'expand-zip-progress':
      e.preventDefault()
      expandFolioZipProgress()
      break
    case 'open-email-template':
      e.preventDefault()
      openEmailTemplateModal()
      break
    case 'close-email-template':
      e.preventDefault()
      closeEmailTemplateModal()
      break
    case 'switch-email-tab':
      e.preventDefault()
      switchEmailTab(trigger.dataset.tab)
      break
    case 'insert-email-tag':
      e.preventDefault()
      insertEmailTag(trigger.dataset.tag)
      break
    case 'reset-email-default':
      e.preventDefault()
      resetEmailDefault()
      break
    case 'save-email-template':
      e.preventDefault()
      saveEmailTemplate()
      break
    case 'start-edit-title':
      e.preventDefault()
      startEditTitle()
      break
    case 'save-edit-title':
      e.preventDefault()
      saveEditTitle()
      break
    case 'cancel-edit-title':
      e.preventDefault()
      cancelEditTitle()
      break
    case 'toggle-master-checkbox':
      toggleMasterCheckbox()
      break
    case 'deselect-all':
      e.preventDefault()
      deselectAll()
      break
    case 'bulk-resend-selected':
      e.preventDefault()
      bulkResendSelected()
      break
    case 'bulk-delete-selected':
      e.preventDefault()
      bulkDeleteSelected()
      break
  }
})

// Submitter row checkbox change
document.addEventListener('change', (e) => {
  if (e.target.matches('[data-submitter-checkbox]')) {
    updateSelectionState()
  }
})

// Keyboard navigation in email input & title input
document.addEventListener('keyup', (e) => {
  const titleInput = e.target.closest('#folio-title-input')
  if (titleInput) {
    if (e.key === 'Enter') saveEditTitle()
    else if (e.key === 'Escape') cancelEditTitle()
    return
  }

  const input = e.target.closest('[data-email-input-for]')
  if (!input) return

  const submitterId = input.dataset.emailInputFor
  if (e.key === 'Enter') {
    saveSubmitterEmail(submitterId)
  } else if (e.key === 'Escape') {
    cancelEditEmail(submitterId)
  }
})

// Handle background zip compiling stream events
window.addEventListener('programme-action', (event) => {
  const folioContainer = document.getElementById('folio-zip-progress-container')
  const btn = document.getElementById('folio-download-all-btn')
  if (!folioContainer && !btn) return

  const payload = typeof event.detail === 'string' ? JSON.parse(event.detail) : event.detail
  const textEl = document.getElementById('folio-download-all-text')
  if (!payload) return

  if (payload.action === 'zip_progress') {
    if (btn) btn.disabled = true
    if (textEl) textEl.textContent = 'Compiling ZIP...'
    updateFolioZipProgress(payload.current, payload.total, payload.name)
  } else if (payload.action === 'zip_ready') {
    if (btn) {
      btn.disabled = false
      if (textEl) textEl.textContent = 'Download All'
    }
    setTimeout(() => {
      hideFolioZipProgress()
    }, 1200)

    if (payload.url) {
      const now = Date.now()
      if (window._doccuLastDownloadedZipUrl === payload.url && (now - (window._doccuLastDownloadedZipTime || 0)) < 5000) {
        return
      }
      window._doccuLastDownloadedZipUrl = payload.url
      window._doccuLastDownloadedZipTime = now

      const a = document.createElement('a')
      a.href = payload.url
      a.setAttribute('download', '')
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  } else if (payload.action === 'toast' && payload.type === 'error') {
    if (btn) {
      btn.disabled = false
      if (textEl) textEl.textContent = 'Download All'
    }
    hideFolioZipProgress()
    alert(payload.message || 'An error occurred during download.')
  }
})

// Turbo-resilient live sync polling
function isUserBusy () {
  const bulkModal = document.getElementById('bulk-resend-modal')
  if (bulkModal && !bulkModal.classList.contains('hidden')) return true
  const individualModal = document.getElementById('individual-resend-modal')
  if (individualModal && !individualModal.classList.contains('hidden')) return true
  const emailModal = document.getElementById('folio-email-template-modal')
  if (emailModal && !emailModal.classList.contains('hidden')) return true
  const ccOverlay = document.getElementById('cc-overlay')
  if (ccOverlay && !ccOverlay.classList.contains('hidden')) return true

  const activeEl = document.activeElement
  if (activeEl && (activeEl.tagName === 'INPUT' || activeEl.tagName === 'TEXTAREA')) {
    return true
  }
  const titleEdit = document.getElementById('folio-title-edit')
  if (titleEdit && !titleEdit.classList.contains('hidden')) return true
  const anyChecked = document.querySelector('[data-submitter-checkbox]:checked')
  if (anyChecked) return true
  const openEdit = document.querySelector('[data-email-edit-for]:not(.hidden)')
  if (openEdit) return true
  const kebabMenu = document.getElementById('folio-status-kebab-menu')
  if (kebabMenu && !kebabMenu.classList.contains('hidden')) return true

  return false
}

function syncFolioState () {
  if (isFetching || isUserBusy()) return
  const syncRoot = document.querySelector('[data-folio-live-sync="true"]')
  if (!syncRoot) return

  isFetching = true
  const fetchUrl = new URL(window.location.href)
  fetchUrl.searchParams.set('_sync', Date.now().toString())

  window.fetch(fetchUrl.toString(), {
    headers: {
      'X-Requested-With': 'XMLHttpRequest',
      Accept: 'text/html'
    }
  })
    .then((res) => {
      if (!res.ok) return null
      return res.text()
    })
    .then((html) => {
      if (!html || isUserBusy()) return

      const parser = new DOMParser()
      const doc = parser.parseFromString(html, 'text/html')

      const newBadge = doc.getElementById('folio-status-badge')
      const curBadge = document.getElementById('folio-status-badge')
      if (newBadge && curBadge && newBadge.outerHTML !== curBadge.outerHTML) {
        curBadge.outerHTML = newBadge.outerHTML
      }

      const newActions = doc.getElementById('folio-header-actions')
      const curActions = document.getElementById('folio-header-actions')
      if (newActions && curActions && newActions.innerHTML.trim() !== curActions.innerHTML.trim()) {
        curActions.innerHTML = newActions.innerHTML
      }

      const newTable = doc.getElementById('folio-table-section')
      const curTable = document.getElementById('folio-table-section')
      if (newTable && curTable) {
        const cleanNew = newTable.innerHTML.replace(/[?&]_sync=\d+/g, '').trim()
        const cleanCur = curTable.innerHTML.replace(/[?&]_sync=\d+/g, '').trim()
        if (cleanNew !== cleanCur) {
          const scrollable = curTable.querySelector('.overflow-y-auto')
          const prevScrollTop = scrollable ? scrollable.scrollTop : 0
          curTable.innerHTML = newTable.innerHTML
          if (prevScrollTop > 0) {
            const newScrollable = curTable.querySelector('.overflow-y-auto')
            if (newScrollable) newScrollable.scrollTop = prevScrollTop
          }
        }
      }

      const newBulkModal = doc.getElementById('bulk-resend-modal')
      const curBulkModal = document.getElementById('bulk-resend-modal')
      if (newBulkModal && curBulkModal && curBulkModal.classList.contains('hidden') && newBulkModal.innerHTML.trim() !== curBulkModal.innerHTML.trim()) {
        curBulkModal.innerHTML = newBulkModal.innerHTML
      }

      const newCcData = doc.getElementById('command-centre-data')
      const curCcData = document.getElementById('command-centre-data')
      if (newCcData && curCcData && newCcData.textContent !== curCcData.textContent) {
        curCcData.textContent = newCcData.textContent
      }

      if (newBadge && newBadge.textContent.toUpperCase().includes('COMPLETED')) {
        if (syncTimer) {
          clearInterval(syncTimer)
          syncTimer = null
        }
      }
    })
    .catch(() => {
      // Ignore transient network errors
    })
    .finally(() => {
      isFetching = false
    })
}

function initFolioLiveSync () {
  if (syncTimer) {
    clearInterval(syncTimer)
    syncTimer = null
  }

  const syncRoot = document.querySelector('[data-folio-live-sync="true"]')
  if (!syncRoot) return

  syncTimer = setInterval(() => {
    if (document.visibilityState === 'visible') {
      syncFolioState()
    }
  }, 3500)
}

document.addEventListener('turbo:load', () => {
  initFolioLiveSync()
  updateSelectionState()
})

document.addEventListener('visibilitychange', () => {
  if (document.visibilityState === 'visible') {
    syncFolioState()
  }
})

window.addEventListener('focus', () => {
  syncFolioState()
})

document.addEventListener('turbo:before-cache', () => {
  if (syncTimer) {
    clearInterval(syncTimer)
    syncTimer = null
  }
  closeStatusKebab()
  const menu = document.getElementById('folio-status-kebab-menu')
  const container = document.getElementById('folio-status-kebab-container')
  if (menu && container && menu.parentElement === document.body) {
    container.appendChild(menu)
  }
})

window.addEventListener('scroll', () => {
  closeStatusKebab()
}, { passive: true })

document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    closeStatusKebab()
  }
})
